import React from 'react';


class Comp extends React.Component {
  state = {
    dragging: false,
  }

  dropRef = React.createRef();

  handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({dragging: true});
  }
  handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
  }

  handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({dragging: false});
  }

  handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({dragging: false});
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      this.props.handleDrop(e.dataTransfer.files[0]);
    }
  }

  componentDidMount() {
    let div = this.dropRef.current;
    div.addEventListener('dragenter', this.handleDragEnter);
    div.addEventListener('dragleave', this.handleDragLeave);
    div.addEventListener('dragover', this.handleDragOver);
    div.addEventListener('drop', this.handleDrop);
  }

  componentWillUnmount() {
    let div = this.dropRef.current;
    div.removeEventListener('dragenter', this.handleDragIn);
    div.removeEventListener('dragleave', this.handleDragOut);
    div.removeEventListener('dragover', this.handleDrag);
    div.removeEventListener('drop', this.handleDrop);
  }


  render() {
    return (
      <div
        style={{
          border: (this.state.dragging === true) ? 'dashed red 5px' : 'dashed grey 5px',
          position:'relative',
        }}
        ref={this.dropRef}
        className='round12'
      >

        {this.props.children}
      </div>
    )
  }
}
export default Comp;
